import {
  ObservabilityToolType,
  type TeamExternalIntegration
} from 'types/api/status-checks/status-check'
import { OBSERVABILITY_TOOL_DISPLAY_NAME } from 'utils/status-checks/status-checks-utils'

export function findMatchingIntegrationByAttributes(
  domain: string | null | undefined,
  integrationName: string,
  // Must be of 'string' type as this comes from route params which can be modified by users
  observabilityToolType: string
) {
  return function ({
    domain: domainName,
    name,
    observabilityToolType: type
  }: TeamExternalIntegration) {
    const hasMatchingNameAndType =
      name === integrationName && type === observabilityToolType

    return domain
      ? domain === domainName && hasMatchingNameAndType
      : hasMatchingNameAndType
  }
}

export function getDisplayIntegrationName({
  domain,
  integrationName,
  observabilityToolType
}: {
  domain?: string
  integrationName: string
  observabilityToolType: string
}) {
  if (observabilityToolType === ObservabilityToolType.AWS && domain) {
    return `${integrationName} - ${domain}`
  }

  if (observabilityToolType === ObservabilityToolType.GRAFANA) {
    return OBSERVABILITY_TOOL_DISPLAY_NAME[ObservabilityToolType.GRAFANA]
  }

  return integrationName ?? 'Other'
}
